import { alpha, styled } from '@mui/material/styles';
import { PRIMARY } from 'themes/colors';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
import Iconify from '../../components/Iconify';
import { AccountPopover } from './AccountPopover';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_HEIGHT = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
  borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.1)}`,
  backgroundColor: theme.palette.background.paper,
  backdropFilter: 'blur(8px)',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_HEIGHT,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

// ----------------------------------------------------------------------

export function Navbar({ onOpenSidebar }: { onOpenSidebar: any }) {

  return (
    <RootStyle>
      <ToolbarStyle>
        {/* Hamburger — mobile only */}
        <IconButton
          onClick={onOpenSidebar}
          size="small"
          sx={{
            mr: 1.5,
            p: 1,
            borderRadius: 2.5,
            color: 'text.secondary',
            display: { lg: 'none' },
            '&:hover': { bgcolor: alpha(PRIMARY.main, 0.08), color: 'primary.main' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" width={22} height={22} />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
